import type { FetchResult } from '@apollo/client';
import { createClient } from '@/shared/api';
import type { UpdateStudySettingMutation, UpdateStudySettingMutationVariables } from '@/shared/api';
import UPDATE_STUDY_SETTING_MUTATION from '../mutations/updateStudySetting';

/**
 * Saves the recording and reporting settings of a study. Runs UPDATE_STUDY_SETTING_MUTATION, throws the returned message when isSuccess is false, and hands back the raw Apollo mutation result.
 *
 * @param input - Mutation input payload.
 * @returns The raw Apollo mutation result.
 */
const handleUpdateStudySetting = async (
  input: UpdateStudySettingMutationVariables['input'],
): Promise<FetchResult<UpdateStudySettingMutation>> => {
  const client = createClient();
  const updateStudy = await client.mutate<
    UpdateStudySettingMutation,
    UpdateStudySettingMutationVariables
  >({
    mutation: UPDATE_STUDY_SETTING_MUTATION,
    variables: { input },
  });
  if (!updateStudy?.data?.updateStudySetting?.isSuccess) {
    throw new Error(updateStudy?.data?.updateStudySetting?.message ?? undefined);
  }
  return updateStudy;
};

export default handleUpdateStudySetting;
